import EventIcon1 from "../assets/images/events_icon1.png";
import EventIcon2 from "../assets/images/events_icon2.png";
import EventIcon3 from "../assets/images/events_icon3.png";
import EventIcon4 from "../assets/images/events_icon4.png";
import FriendsIcon1 from "../assets/images/friends_logo_1.png";
import FriendsIcon2 from "../assets/images/friends_logo_2.png";
import FriendsIcon3 from "../assets/images/friends_logo_3.png";
import FriendsIcon4 from "../assets/images/friends_logo_4.png";
import motoPhoto from "../assets/images/moto.jpg";
import motoPhoto2 from "../assets/images/moto2.png";

export const EVENTS = [
  {
    pk: 1,
    icon: EventIcon1,
    date: "17 сентября 2022",
    title: "День добрых дел в Гатчине",
    link: "https://www.youtube.com/embed/OQmXrKPeOVo?si=3ul0ve2vLT7y5hhh",
    photo: [{ link: motoPhoto }, { link: motoPhoto2 }, { link: motoPhoto }],
    text: `— Ольга Ивановна, вы нас ждёте? — Мы всегда вас ждём, ключ под ковриком! Разговор с директором центра Дарина в Гатчине по согласованию поездки через год знакомства уже выглядит так. Это очень важно, когда доверие заработано и уже не надо объяснять, кто мы и зачем хотим приехать! Дату обозначили… осталось только ждать!
    В прошлом году дети мучали воспитателей вопросами — а когда приедут, а завтра уже скоро? В этом году всё капельку изменилось — мы, взрослые ждали встречу с малышами и не обращали на прогноз погоды.
    И снова точка сбора, постояшки и новенькие, инструктаж и в путь! Нас не пугали тучи и огромная пробка, которую к удивлению быстро проскочили. Водители машин видимо чувствовали, что едем дарить эмоции!
    Приехали и сразу были окружены детьми. Было много новых, но были и те, которые уже стали родными и ждали этой встречи с нетерпеньем. Дождик всё-таки нас настиг, спрятали железных коней под деревьями, а вот детей спрятать под крышей не получилось. Они сразу же оседлали мотоциклы и разогнали тучи ревом мотоциклов. Даже мысли о покатушках остались где-то далеко.
    Горящие глаза, руки на руле, можно открутить ручку газа и почувствовать себя настоящим мотоциклистом. А самое главное — это внимание взрослых, которые терпеливо отвечали на все вопросы, были просто рядом, чего им так не хватает.
    И вот, наступил черёд покатушек! «Старенькие» уже знают правила — не толпиться, не залезать без отмашки на мотоцикл и обязательно надеть шлем! И только накрапывающий дождь, смог остановить это безудержное веселье!
    А во время покатушек под крышей беседки случилось волшебство и появилась скатерть -самобранка с горячими вкуснейшими хот-догами, конфетами, арбузом, соками и чаем (почти из самовара)!
    Подкрепились и появились сил для игр и общения. Кто-то залез на руки, кто-то играл в мячик, пускал мыльные пузыри или просто держал взрослого за руки, которые делились своим душевным теплом. В этот раз, как никогда, часто звучал вопрос: -А вы когда ещё придете?
    В заключении этого замечательного дня добавили ярких красок!
    Ну и конечно - общее фото и крепкие обнимашки!
    Спасибо всем волшебникам и феям, которые так или иначе приняли участие в это Дне Добрых дел! Без вас не было бы этих счастливых улыбок!
    Отдельное спасибо мотоклубам «Русские медведи» и «Крутящий момент СпБ» за организованный сбор одежды!
    За полные животики от вкуснейших пицц огромное спасибо нашим друзьям - «BERR HOUSE»!`,
  },
  {
    pk: 2,
    icon: EventIcon2,
    date: "30 июля 2022",
    title: "МотоЭмоции в Всеволожске",
    link: "",
    photo: [{ link: motoPhoto }, { link: motoPhoto2 }, { link: motoPhoto }],
    text: "Text 2",
  },
  {
    pk: 3,
    icon: EventIcon3,
    date: "25 июня 2022",
    title: "Хоспис Токсово",
    link: "",
    photo: [{ link: motoPhoto }, { link: motoPhoto2 }, { link: motoPhoto }],
    text: "Text 3",
  },
  {
    pk: 4,
    icon: EventIcon4,
    date: "17 сентября 2022",
    title: "День добрых дел в Гатчине",
    link: "",
    photo: [{ link: motoPhoto }, { link: motoPhoto2 }, { link: motoPhoto }],
    text: "Text 4",
  },
  {
    pk: 5,
    icon: EventIcon3,
    date: "25 июня 2022",
    title: "Хоспис Токсово",
    link: "",
    photo: [{ link: motoPhoto }, { link: motoPhoto2 }, { link: motoPhoto }],
    text: "Text 5",
  },
];

export const FRIENDS = [
  {
    id: 1,
    icon: FriendsIcon1,
    description: "Логотип друга",
  },
  {
    id: 2,
    icon: FriendsIcon2,
    description: "Логотип друга",
  },
  {
    id: 3,
    icon: FriendsIcon3,
    description: "Логотип друга",
  },
  {
    id: 4,
    icon: FriendsIcon4,
    description: "Логотип друга",
  },
  {
    id: 5,
    icon: FriendsIcon3,
    description: "Логотип друга",
  },
  {
    id: 6,
    icon: FriendsIcon3,
    description: "Логотип друга",
  },
  {
    id: 7,
    icon: FriendsIcon3,
    description: "Логотип друга",
  },
];

export const FEEDBACKS = [
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
  {
    name: "John",
    email: "john@example.com",
    text: "Text text text text text text text text text text text text text text text text text text text text",
  },
];
